import ManageDeviceDialog from './manage-device-dialog-container'
export default ManageDeviceDialog
